import { createContext } from 'react';

export type ModalContentType = 'consult' | 'order';

interface ModalContextProps {
  isModalOpened: boolean;
  contentType: ModalContentType;
  openModal: (type: ModalContentType) => void;
  closeModal: () => void;
}

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);
